import { GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { PageStyle } from "@insite/mobius/Page";
import { clearfixStyles, lazyLoadKeyframes, siteWidthStyles } from "@store/theme/mixins";
import { css } from "styled-components";

export default {
    css: css`
        /* stylelint-disable property-no-vendor-prefix */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type="number"] {
            -moz-appearance: textfield !important;
        }
        /* stylelint-enable property-no-vendor-prefix */

        ${GridWrapper} {
            ${clearfixStyles()}
            max-width: none;
        }

        ${GridItemStyle} {
            overflow-wrap: normal;
            word-wrap: normal;
            -ms-word-break: normal;
            word-break: normal;
        }

        #react-app > div:first-child {
            min-height: 100vh;
            display: flex;
            flex-direction: column;

            @media print {
                display: block !important;
            }

            > footer {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                justify-content: flex-end;
            }
        }

        header + p,
        header + ${PageStyle} + p {
            ${siteWidthStyles()}
            width: 100%;
            padding-top: 1em;
        }

        ${lazyLoadKeyframes()}
    `,
};
